import React, { useState } from "react";
import { avatarColorClasses } from "./constants";

export const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase() || "?";

const colorClassFor = (name: string) =>
  avatarColorClasses[
    Array.from(name).reduce((sum, char) => sum + char.charCodeAt(0), 0) % avatarColorClasses.length
  ];

export const PersonAvatar = ({ name, url, sizeClass }: { name: string; url: string | null; sizeClass: string }) => {
  const [failed, setFailed] = useState(false);
  if (url && !failed) {
    return (
      <span className={`avatar avatar-rounded ${sizeClass}`}>
        <img src={url} alt={name} onError={() => setFailed(true)} />
      </span>
    );
  }
  return (
    <span className={`avatar avatar-rounded ${sizeClass} initials-avatar ${colorClassFor(name)}`} title={name}>
      {initialsOf(name)}
    </span>
  );
};

export const MoneyBagIcon = ({ color, symbol }: { color: string; symbol: string }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <ellipse cx="12" cy="2.3" rx="6" ry="2.3" fill="#fff" />
    <path fill="#fff" d="M7.5 6h9c2.7 2 4.5 5.2 4.5 9.2 0 5-3.6 8.8-9 8.8S3 20.2 3 15.2C3 11.2 4.8 8 7.5 6z" />
    <text
      x="12"
      y="15.4"
      textAnchor="middle"
      dominantBaseline="central"
      fill={color}
      fontSize={symbol.length > 2 ? 5 : symbol.length > 1 ? 7 : 9.5}
      fontWeight={700}
      fontFamily="Inter, Arial, sans-serif"
    >
      {symbol}
    </text>
  </svg>
);

export const PDF_CAPTURE_CSS = `
  .new-dashboard .kpi-card {
    -webkit-mask: none !important;
    mask: none !important;
  }
  .new-dashboard .kpi-card-wrap::before {
    content: "";
    position: absolute;
    top: -11px;
    right: -11px;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: #f7f8f9;
    z-index: 1;
  }
  .new-dashboard .kpi-icon {
    z-index: 2;
  }
`;

export const SectionTitle = ({ title }: { title: string }) => (
  <h5 className="mb-0 fs-16 fw-bold d-inline-flex align-items-center">
    <span className="line-title d-block me-2" />
    {title}
  </h5>
);

export const EmptyState = ({ message, compact = false }: { message: string; compact?: boolean }) => (
  <div
    className={`d-flex flex-column align-items-center justify-content-center text-center nd-empty ${
      compact ? "py-4" : "py-5"
    }`}
  >
    <i className="ti ti-chart-bar-off fs-1 mb-2" />
    <p className="mb-0">{message}</p>
  </div>
);
